export interface Point {
  x: number;
  y: number;
}

export interface ImmervisionData {
  rotation: Point;
  zoom: number;
}

export type FishEyeViewType = "single" | "ePtz" | "perimeter" | "quad";
export type MountingType = "WALL" | "CEILING";

const offset = -0.35;
const ceilingDefaultValues: Record<FishEyeViewType, ImmervisionData[]> = {
  single: [{ rotation: { x: 0, y: 0 }, zoom: 116 }],
  ePtz: [{ rotation: { x: 0, y: 0 }, zoom: 50 }],
  perimeter: [
    { rotation: { x: -163, y: 1.058 }, zoom: 1 },
    { rotation: { x: -163, y: 0.43 }, zoom: 1 },
  ],
  quad: [
    { rotation: { x: -0.4, y: offset + Math.PI / 2 }, zoom: 50 },
    { rotation: { x: -0.4, y: offset + Math.PI }, zoom: 50 },
    { rotation: { x: -0.4, y: offset + (Math.PI * 3) / 2 }, zoom: 50 },
    { rotation: { x: -0.4, y: offset + 0 }, zoom: 50 },
  ],
};
const wallDefaultValues: Record<FishEyeViewType, ImmervisionData[]> = {
  single: [{ rotation: { x: 0, y: 0 }, zoom: 116 }],
  ePtz: [{ rotation: { x: 0, y: 0 }, zoom: 50 }],
  perimeter: [
    { rotation: { x: -163, y: 0 }, zoom: 0 },
    { rotation: { x: -163, y: 0.43 }, zoom: 1 },
  ],
  quad: [
    {
      rotation: {
        x: 0.14999999999999997,
        y: 0.36968719742681855,
      },
      zoom: 50,
    },
    {
      rotation: {
        x: -0.04000000000000006,
        y: 1.2296871974268184,
      },
      zoom: 60.775312500000005,
    },
    {
      rotation: {
        x: -0.8773234292618491,
        y: 0.024999999999999897,
      },
      zoom: 76.79365058647076,
    },
    {
      rotation: {
        x: 0.018,
        y: -1.2,
      },
      zoom: 50,
    },
  ],
};

export class ImmervisionDataManager {
  private values: Record<FishEyeViewType, ImmervisionData[]>;
  private mounting: MountingType;
  private rpl: "B9VVT";
  private wallOffset = Math.PI / 5;
  private ceilingOffset = Math.PI;
  private offset = this.ceilingOffset;

  constructor(mounting: MountingType) {
    const defaultValues = mounting === "WALL" ? wallDefaultValues : ceilingDefaultValues;
    this.values = JSON.parse(JSON.stringify(defaultValues));
    this.mounting = mounting;
    this.rpl = "B9VVT";
    this.offset = this.mounting === "WALL" ? this.wallOffset : this.ceilingOffset;
  }

  updateMounting(mounting: MountingType) {
    this.mounting = mounting;
    this.offset = this.mounting === "WALL" ? this.wallOffset : this.ceilingOffset;
    const defaultValues = mounting === "WALL" ? wallDefaultValues : ceilingDefaultValues;
    this.values = JSON.parse(JSON.stringify(defaultValues));
  }

  getMounting(): MountingType {
    return this.mounting;
  }

  getOffset(): number {
    return this.offset;
  }

  getRpl(): "B9VVT" {
    return this.rpl;
  }

  updateRotation(fishEyeViewType: FishEyeViewType, viewIndex: number, point: Point): void {
    this.values[fishEyeViewType][viewIndex].rotation = point;
  }

  updateZoom(fishEyeViewType: FishEyeViewType, viewIndex: number, zoomValue: number): void {
    this.values[fishEyeViewType][viewIndex].zoom = zoomValue;
  }

  getRotation(fishEyeViewType: FishEyeViewType, viewIndex: number): Point {
    return this.values[fishEyeViewType][viewIndex].rotation;
  }

  getZoom(fishEyeViewType: FishEyeViewType, viewIndex: number): number {
    return this.values[fishEyeViewType][viewIndex].zoom;
  }
}
